import React from 'react';
import AllTpJobPaymentsTab from './AllTpJobPaymentsTab';
import PendingApprovalTpJobTab from './PendingApprovalTpJobTab';
import TabbedPage from '../../../../Elements/TabbedPage';
import OverWindow from '../../../../Elements/TabList/OverWindow';

export default class ShowTpJobEvaluatorPaymentsOverDataWindow extends React.Component {
  static defaultProps = {
    tpJob: {},
    clickOnCancel: () => {
      alert('Missing function');
    },
  };

  tabs = [
    {
      label: 'All Payments',
      id: 'alltppayments',
      icon: 'fa-solid fa-memo-circle-info',
      component: (
        <AllTpJobPaymentsTab
          tpJob={this.props.tpJob}
          newButtonsEnabled={true}
        />
      ),
    },
    {
      label: 'Pending Payments',
      id: 'tppendingapproval',
      icon: 'fa-solid fa-memo-circle-info',
      component: (
        <PendingApprovalTpJobTab
          tpJob={this.props.tpJob}
          newButtonsEnabled={true}
        />
      ),
    },
  ];

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={`Third-Party Job Payments (Third-Party ID: ${this.props.tpJob.ThirdPartyJobId})`}
        closeOnClickOutside={false}
      >
        <div className='verticalScroll showassignmentlistheight'>
          <TabbedPage tabs={this.tabs} />
        </div>
      </OverWindow>
    );
  }
}
